module.exports = __webpack_public_path__ + "static/media/FinalArt.53e8bef2.jpg";